<template>
	<div :class="classes"
		:style="styles"
	>
		<font-awesome-icon
			class="nav-sidebar-tooltip__caret text-ms1"
			:icon="[`fas`, `caret-left`]"
		/>
		<div class="nav-sidebar-tooltip__text"><slot></slot></div>
	</div>
</template>

<script>

export default {
	name: "NavSidebarTooltip",
	props: {
		className: {
			type: String,
			default: "",
		},
		groupTop: {
			type: Number,
			required: true,
		},
		groupBottom: {
			type: Number,
			required: true,
		},
		groupRight: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			bounds: null,
		};
	},
	computed: {
		classes() {
			return `nav-sidebar-tooltip text-ms0 ${ this.className }`.trim();
		},
		styles() {
			if ( !this.bounds ) {
				return "";
			}

			const { groupRight, groupTop, groupBottom, } = this;
			const groupHeight = groupBottom - groupTop;
			// eslint-disable-next-line no-magic-numbers
			const groupHalfHeight = groupHeight / 2;

			const { top: tooltipTop, bottom: tooltipBottom, } = this.bounds;
			const tooltipHeight = tooltipBottom - tooltipTop;
			// eslint-disable-next-line no-magic-numbers
			const tooltipHalfHeight = tooltipHeight / 2;

			return [
				// eslint-disable-next-line no-magic-numbers
				`left: ${ ( groupRight + 5 ) }px;`,
				// eslint-disable-next-line no-magic-numbers
				`top: ${ ( groupTop - tooltipHalfHeight + groupHalfHeight + 2 ) }px;`,
			].join( "" );
		},
	},
	mounted() {
		this.bounds = this.$el.getBoundingClientRect();
	},
};
</script>

<style lang="scss" scoped>
$nav-sidebar-tooltip-color: $mono-000;
$nav-sidebar-tooltip-background-color: $gray-800;

.nav-sidebar-tooltip {
	color: $nav-sidebar-tooltip-color;
	background-color: $nav-sidebar-tooltip-background-color;
	position: fixed;
	padding: 0.5rem;
	margin-left: 0.5rem;
	top: 1rem;

	border-radius: 0.5rem;
	box-shadow: 0 0.1875rem 0.375rem 0.0625rem rgba(33, 45, 99, 0.1), 0 1.3125rem 1.875rem -1.25rem rgba(33, 45, 99, 0.2);
}

.nav-sidebar-tooltip__caret {
	position: absolute;
	left: -0.3125rem;
	top: 0.5625rem;
	color: $nav-sidebar-tooltip-background-color;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar/NavSidebarTooltip.vue